import { MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IHolding } from "src/app/interfaces/holding";
import { environment } from "src/environments/environment.prod";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-holding-entry",
  templateUrl: "./add-holding-entry.component.html",
  styleUrls: ["./add-holding-entry.component.css"]
})
export class AddHoldingEntryComponent implements OnInit {
  imgURL: any;
  form: FormGroup;
  url = environment.BaaseUrl;
  fileName: string;
  fielExtension: string;
  base64textString: string;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private dialogRef: MatDialogRef<AddHoldingEntryComponent>
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      Title: [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50),
          Validators.minLength(3)
        ])
      ],
      FileData: [null],
      FileExtension:['png'],
      FileDisplayName: [null],
      FileAddress: [null],
      HoldingEncryptCode: [null]
    });
  }

  onFileChange(event) {
    var files = event.target.files;
    var file = files[0];
    if (files && file) {
      if (file.size <= 100000) {
        this.fileName = file.name;
        this.form.patchValue({
          FileDisplayName: file.name
        });
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      } else {
        this.snackBar.OpenSnackBar(
          this.translate.get("require.fileUpload", {
            size: "100kb"
          }),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
    }
  }
  _handleReaderLoaded(readerEvt) {
    this.imgURL = "data:image/png;base64," + btoa(readerEvt.target.result);
    this.form.patchValue({
      FileData: btoa(readerEvt.target.result)
    });
  }

  submit(data: IHolding) {
    if (data.FileData) {
      this.holdingService.add(data).subscribe(
        () => {
          this.dialogRef.close();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.holding"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error)
        }
      );
    } else {
      this.snackBar.OpenSnackBar(
        this.translate.get("require.image"),
        "ok",
        3000,
        SoundEnum.beep
      );
    }
  }
}
